import {
  Container,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Paper,
  Button,
} from "@mui/material";
import { usePaystackPayment } from "react-paystack";

export default function Test() {
  const config = {
    reference: new Date().getTime().toString(),
    email: "test@test.com",
    amount: 10000,
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_TEST as string,
    currency: "NGN",
  };

  const initializePayment = usePaystackPayment(config);

  const onSuccess = (reference: any) => {
    console.log("success", reference);
  };

  const onClose = () => {
    console.log("closed");
  };

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.1)",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 3,
          maxWidth: 400,
          width: "100%",
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "primary.main",
              mr: 1,
            }}
          />
          <Box>
            <Typography variant="body2" color="text.secondary">
              test@test.com
            </Typography>
            <Typography variant="h6" color="success.main">
              Pay NGN 100
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Box
            sx={{
              display: "inline-block",
              px: 1,
              py: 0.5,
              backgroundColor: "#fff3cd",
              borderRadius: 1,
              mb: 1,
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
              TEST
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            Use any of the options below to test the payment flow
          </Typography>
        </Box>

        <RadioGroup defaultValue="" sx={{ mb: 2 }}>
          <FormControlLabel value="success" control={<Radio />} label="Success" />
          <FormControlLabel value="bank" control={<Radio />} label="Bank Authentication" />
          <FormControlLabel value="declined" control={<Radio />} label="Declined" />
        </RadioGroup>

        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#4caf50",
              "&:hover": {
                backgroundColor: "#45a049",
              },
            }}
            onClick={() => {
              initializePayment({
                onSuccess,
                onClose,
              });
            }}
          >
            Pay NGN 100
          </Button>
        </Box>

        <Typography variant="body2" color="primary" sx={{ textAlign: "center", cursor: "pointer" }}>
          Use another card
        </Typography>
      </Paper>
    </Container>
  );
}
